// extracted by mini-css-extract-plugin
module.exports = {"image":"UploadedPhotoModal_image__3M23B","upload-image-container":"UploadedPhotoModal_upload-image-container__JR1hW","footer":"UploadedPhotoModal_footer__3FJ-Y"};